import React from "react";
import { Paper, Stack } from "@mui/material";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import _ from "lodash";
import { capitalize, removeDetectKeywordFromVisuals } from "../../helpers";
import CardHeaderTitle from '../card-header-title';
import ProgressTable from "../progress-table";
import { toggleButtonStyle } from "../../consts";

const InsightsCard = ({ data, colours, themeMode }) => {
    const [pickedInsightAgent, setPickedInsightAgent] = React.useState("Agent");

    return (
        <Paper
            sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                borderRadius: 2.5,
                padding: 3,
                boxSizing: "border-box",
            }}
        >
            <Stack
                direction="row"
                flexWrap="wrap"
                gap={0.5}
                justifyContent="space-between"
                alignItems="center"
            >
                <CardHeaderTitle
                    icon="activity"
                    title="Insights"
                    tooltip="Speaker analytics providing insights on individual speaker performance"
                />
                <ButtonGroup
                    variant="contained"
                    aria-label="outlined primary button group"
                    className="buttons-border-extend"
                >
                    <Button
                        onClick={() => setPickedInsightAgent("Agent")}
                        style={toggleButtonStyle(pickedInsightAgent === "Agent", colours, themeMode)}
                    >
                        Agent
                    </Button>
                    <Button
                        style={toggleButtonStyle(pickedInsightAgent === "Customer", colours, themeMode)}
                        onClick={() => setPickedInsightAgent("Customer")}
                    >
                        Client
                    </Button>
                </ButtonGroup>
            </Stack>
            <ProgressTable
                data={_.filter(data?.trackerhits || [], { for: pickedInsightAgent })}
                filterKey="tracker"
                sortKey="hits"
                maxItems={20}
                getColorFn={() => "warning"}
                capCase={(val) => capitalize(removeDetectKeywordFromVisuals(val))}
            />
        </Paper>
    );
};

export default InsightsCard;
